import axios from 'axios';

// ─── Constante de almacenamiento ──────────────────────────────────────────────
export const JWT_STORAGE_KEY = 'erp_token';

/**
 * Instancia de Axios configurada para la API del ERP.
 *
 * - baseURL apunta a /api/v1 (Nginx lo proxifica a localhost:4020)
 * - El interceptor de request inyecta el JWT como Bearer token si existe
 * - El interceptor de request inyecta x-tenant-slug desde sessionStorage
 *   (lo escribe AuthContext justo antes de hacer login)
 */
const api = axios.create({
  baseURL: '/api/v1',
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ─── Interceptor de request ───────────────────────────────────────────────────
api.interceptors.request.use((config) => {
  // JWT Bearer token
  const token = localStorage.getItem(JWT_STORAGE_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // x-tenant-slug — requerido por tenantHandler del backend.
  // Se lee primero de localStorage (persiste entre recargas) y como
  // fallback de sessionStorage (compatibilidad con el flujo de login).
  const slug =
    localStorage.getItem('tenant_slug') ??
    sessionStorage.getItem('tenant_slug');
  if (slug) {
    config.headers['x-tenant-slug'] = slug;
  }

  return config;
});

// ─── Interceptor de response ──────────────────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl: string = error.config?.url ?? '';

    // Solo redirige al login si el 401 viene de una ruta protegida
    // (nunca desde /auth/login para no crear un bucle de redirección)
    const isLoginEndpoint = requestUrl.includes('/auth/login');
    const hasToken = !!localStorage.getItem(JWT_STORAGE_KEY);

    if (status === 401 && !isLoginEndpoint && hasToken) {
      localStorage.removeItem(JWT_STORAGE_KEY);
      sessionStorage.removeItem('tenant_slug');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

export default api;
